import { render, staticRenderFns } from "./SuperAdminConfigurationItem.vue?vue&type=template&id=632174a6&scoped=true&lang=pug"
import script from "./SuperAdminConfigurationItem.vue?vue&type=script&lang=ts"
export * from "./SuperAdminConfigurationItem.vue?vue&type=script&lang=ts"
import style0 from "./SuperAdminConfigurationItem.vue?vue&type=style&index=0&id=632174a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632174a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardText,VSwitch})
